import map from 'lodash/map'
import React, { FC } from 'react'

import { HorizontalSlider } from '@Components/CMS/Sliders/HorizontalSlider'
import { ImageV3 } from '@Components/Image'
import { Page } from '@Generated/graphql'

interface FacetDescriptionOverviewProps {
  pages: Page[]
  setIndex: (index: number) => void
}

export const FacetDescriptionOverview: FC<FacetDescriptionOverviewProps> = ({ pages, setIndex }) => (
  <HorizontalSlider itemHeight={200} itemWidth={266} numberOfElements={pages.length} style={{ overflow: 'hidden', paddingTop: '225px' }}>
    {map(pages, (page, index) => page.image?.url && (
      <ImageV3
        key={page.id}
        alt="test"
        height={200}
        onClick={() => setIndex(index)}
        src={page.image!.url}
        style={{
          cursor: 'pointer',
          padding: '5px',
        }}
        width={200}
      />
    ))}
  </HorizontalSlider>
)
